export const ReleaseErrors = {
  phoneUsed: 'PHONE_USED',
  invalidPin: 'INVALID_PIN',
  taxNotOk: 'TAX_NOT_OK',
} as const;
